import React, { ComponentType } from 'react'
import { Field, FieldProps, FieldAttributes } from 'formik'

interface IFieldWrapperProps extends FieldProps, FieldAttributes<any> {
  component: ComponentType<any>
}

const FieldWrapper =
  (Component: ComponentType<any>) =>
  (props: Omit<IFieldWrapperProps, 'component'>) => (
    <Field component={Component} {...props} />
  )

export default FieldWrapper
